import { componentName, ListItemClass } from './ListItemClass';

customElements.define(componentName, ListItemClass);

export { ListItemClass, componentName };
